import { useState,useEffect } from 'react';
import './App.css'
import Desktop from "./components/Desktop";
import StartUp from './components/StartUp';

function App() {
  const [showWelcome, setShowWelcome] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowWelcome(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);


  return (
    <div className="App">
      <Desktop />
      {showWelcome && <StartUp />}
    </div>
  );
}

export default App;
